export default __webpack_public_path__ + "static/media/Logo-300x277.242f6a34.png";